import { ENV } from "../utils";

export class Activity {
  baseApi = ENV.BASE_API;

  async getActivities(accessToken, active = true) {
    const url = `${this.baseApi}/activities?active=${active}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createActivity(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-activity`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateActivity(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-activity/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteActivity(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-activity/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
